$(function () {
  $('.search-popover').popover({ 
    html : true,
    content: 'ciao'
});
});

/* infinite scroll on product page */


/* initialize AOS */

AOS.init();
